// extracted by mini-css-extract-plugin
export default {"root":"breadcrumbs-module___root___e4c86501","chevron":"breadcrumbs-module___chevron___f4326655"};